import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  placeholder: {
    default: 'Search for records...',
    editor: 'textbox',
  },
  delay: {
    editor: 'number',
    default: 500,
  },
  disabled: {
    default: false,
    editor: 'checkbox',
  },
  clearButton: {
    default: false,
    editor: 'checkbox',
  },
  borderless: {
    default: false,
    editor: 'checkbox',
  },
};

const PlaygroundKnobsV3: Knobs = {
  ...PlaygroundKnobs,
  defaultCriteria: {
    default: '',
    editor: 'textbox',
  },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A tag-searchbox where you can change all the attributes',
  coreComponent: {
    html: `<tag-searchbox{{...knobs}}>
</tag-searchbox>`,
    knobs: PlaygroundKnobs,
  },
  coreComponent_v3: {
    html: `<tag3-searchbox {{...knobs}}>
</tag3-searchbox>`,
    knobs: PlaygroundKnobsV3,
  },
  reactWrapper: { jsx: `<TagSearchbox{{...knobs}} />`, knobs: PlaygroundKnobs },
  reactWrapper_v3: {
    jsx: `<Tag3Searchbox {{...knobs}} onSearch={(e) => console.log(e.detail)} />`,
    knobs: PlaygroundKnobsV3,
  },
};

const CustomiseStory: Story = {
  title: 'Customise',
  description: 'A customised searchbox',
  coreComponent_v3: {
    html: `<tag3-searchbox 
  input-style='{"background-color": "#f3f3f3", "border-top-right-radius": "5px", "border-bottom-right-radius": "5px"}' 
  icon-container-style='{"background-color": "#f3f3f3", "border-top-left-radius": "5px", "border-bottom-left-radius": "5px"}'
  icon-accent="grey-2">
</tag3-searchbox>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Searchbox 
    inputStyle={{backgroundColor: "#f3f3f3", borderTopRightRadius: "5px", borderBottomRightRadius: "5px"}} 
    iconContainerStyle={{backgroundColor: "#f3f3f3", borderTopLeftRadius: "5px", borderBottomLeftRadius: "5px"}}
    iconAccent="grey-2">
  </Tag3Searchbox>`,
  },
};

export const TagSearchboxDocs: Component = {
  type: 'component',
  name: 'searchbox',
  description: 'Renders a searchbox',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'defaultCriteria',
      description: 'The default criteria in the searchbox',
      type: 'string',
    },
    {
      name: 'placeholder',
      default: 'Search for records...',
      description: 'The placeholder on the search input',
      type: 'string',
    },
    {
      name: 'delay',
      default: '500',
      description:
        'The delay in milliseconds after the user stops typing before the search is invoked',
      type: 'number',
    },
    {
      name: 'borderless',
      description: 'When present it removes the border from the input',
      type: 'boolean',
    },
    {
      name: 'disabled',
      description: 'Whether the control is disabled',
      type: 'boolean',
    },
    {
      name: 'clearButton',
      default: 'false',
      description: 'Whether you can clear the search',
      type: 'boolean',
    },
    {
      name: 'icon',
      default: 'Search',
      description: 'The icon name to display in the left of the input',
      type: 'string',
    },
    {
      name: 'iconAccent',
      default: '',
      description: 'The search icon accent',
      type: 'Accent',
    },
    {
      name: 'InputStyle',
      default: '',
      description: 'Style to apply to the input element',
      type: 'string',
    },
    {
      name: 'iconContainerStyle',
      default: '',
      description: 'Style to apply to the icon container element',
      type: 'string',
    },
    {
      name: 'colour-scheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'search',
      description: 'Event raised when the search is invoked',
      parameters: [
        {
          name: 'criteria',
          description: 'The search criteria',
          type: 'string',
        },
      ],
    },
  ],
  methods: [
    {
      name: 'getSearch',
      description: 'Gets the search criteria',
      parameters: [],
      returnType: 'string',
    },
    {
      name: 'setSearch',
      description: 'Sets the search criteria on the search input',
      parameters: [
        {
          name: 'search',
          description: 'The criteria to set',
          type: 'string',
        },
        {
          name: 'suppressSearch',
          description: 'Whether the search event is suppressed',
          type: 'boolean',
          default: 'false',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'focusEditor',
      description: 'Set focus to the search editor text box',
      parameters: [],
      returnType: 'void',
    },
  ],
  stories: [PlaygroundStory, CustomiseStory],
};
